import CompanyLogo from '../images/company.svg'

const getUSBExBillerLogo = (logoURI) => {
  let USBExBillerLogo
  if (logoURI && logoURI.includes('DefaultPerson')) {
    USBExBillerLogo =
      "data:image/svg+xml,%3Csvg enable-background='new 0 0 32 32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='16' cy='16' fill='%23efefef' r='16'/%3E%3Cg fill='%232e96ff'%3E%3Cpath d='m16 19.6c3 0 5.4-2.4 5.4-5.3s-2.4-5.3-5.4-5.3-5.4 2.4-5.4 5.3 2.4 5.3 5.4 5.3zm0-9.1c2.1 0 3.8 1.7 3.8 3.8s-1.7 3.8-3.8 3.8-3.8-1.7-3.8-3.8 1.7-3.8 3.8-3.8z'/%3E%3Cpath d='m16 21.1c-4.7 0-8.7 3.2-9.7 7.6.4.3.9.7 1.4.9.7-4 4.1-7 8.3-7s7.7 3 8.3 7c.5-.3.9-.6 1.4-.9-1-4.3-5-7.6-9.7-7.6z'/%3E%3C/g%3E%3C/svg%3E"
  } else if (
    (logoURI && logoURI.includes('DefaultCompany')) ||
    (logoURI && logoURI.toLowerCase().includes('default'))
  ) {
    USBExBillerLogo = CompanyLogo
  } else {
    USBExBillerLogo = logoURI
  }

  return USBExBillerLogo
}

export default getUSBExBillerLogo
